// extracted by mini-css-extract-plugin
export default {"inputContainer":"CheckBox_inputContainer__j+YKd","customRadio":"CheckBox_customRadio__LZnXQ"};